export enum iframeActionTypes {
  CHAIN_PRODUCT_ID = 'CHAIN_PRODUCT_ID',
  IFRAME_PRODUCT_ID = 'IFRAME_PRODUCT_ID',
}
